<template>
    <tr v-if="$source.displayPagination && (false !== $source.pagination || $source.paginationTotalRows !== false)">
        <td :colspan="$source.getColumns().length">
            <oc-pagination
                ref="pagin"
                v-bind="options"
                @change="onPageChange"
                @change-rows-per-page="onRowsPerPageChange"
            />
        </td>
    </tr>
</template>

<script>
import {cloneObject} from '@utils'

export default {
    name: 'oc-pagination-footer-row',
    inject: ['$source'],
    computed: {
        options() {
            let options = this.$source.pagination;

            if( options === false ) {
                options = {}
            }

            if( options.rowsPerPage === undefined ) {
                options.rowsPerPage = require('@/helpers/Settings').default.rowsPerPage
            }

            if ( options.totalRows === undefined && this.$source.paginationTotalRows !== false ) {
                options.totalRows = this.$source.paginationTotalRows
            }

            return options
        }
    },
    methods: {
        onRowsPerPageChange(rowsPerPage) {
            this.$source.conditionsState.pagination.rowsPerPage = rowsPerPage

            this.$source.$emit('on-rows-per-page-change', rowsPerPage)
            this.$source.$emit('change-internal', this.$source.conditionsState)
        },
        onPageChange(page) {
            this.$source.conditionsState.pagination.page = page

            this.$source.$emit('on-page-change', page)
            this.$source.$emit('change-internal', this.$source.conditionsState)
        }
    }
}
</script>
